import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { insertPaymentMethodApi, updatePaymentMethodApi } from "src/api/paymentMethodApi";
import FormikInput from "src/components/FormikInput ";
import { notification } from "src/utils/messages";
import * as Yup from "yup";

export default function PaymentMethodInsertUpdateModal({
  addEditModal,
  toggleAddEditModal,
  modalType,
  rowData,
  getPaymentMethod
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [loader, setLoader] = useState(false);

  const handlePaymentMethodSubmit = async (data) => {
    if (modalType === "Edit") {
      setLoader(true);
      let resp = await updatePaymentMethodApi({
        ...data,
        p_m_id: rowData.p_m_id
      });
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();

        toggleAddEditModal();
        getPaymentMethod();
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    } else {
      setLoader(true);
      let resp = await insertPaymentMethodApi(data);
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();

        toggleAddEditModal();
        getPaymentMethod();
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    }
  };

  const validationSchema = Yup.object({
    method_name: Yup.string().required("Payment Method Name is required")
  });

  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {modalType} Payment Method
        </Typography>
        <hr />

        <Formik
          initialValues={{
            method_name: modalType === "Edit" ? rowData?.method_name : ""
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => handlePaymentMethodSubmit(values)}
        >
          <>
            <Form>
              <Stack>
                <Grid container spacing={1} sx={{ alignItems: "flex-start", mt: "10px" }}>
                  <Grid item xs={12}>
                    <FormikInput name="method_name" label="Payment Method Name" required />
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => toggleAddEditModal()}
                      style={{ marginTop: "15px", marginRight: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      type="submit"
                      disabled={loader}
                    >
                      Submit
                      {loader && (
                        <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Form>
          </>
        </Formik>
      </Box>
    </Modal>
  );
}
